import { getContentHasVariants } from '../helpers'
import { useContentOrTemplate, useIsMultistep } from '../hooks'

import MultiStepPreview from './MultiStepPreview'
import NinjaPreview from './NinjaPreview'

export type PageState = 'showNinja' | 'showPreview' | 'hideBoth'

const Preview = () => {
  const { isMultistep } = useIsMultistep()
  const { content } = useContentOrTemplate()

  const hasVariants = getContentHasVariants(content)
  const isCustom = content?.elements.length && content?.elements.length > 1

  const getState = (): PageState => {
    if ((isMultistep && hasVariants) || isCustom) {
      return 'showPreview'
    } else if (!isMultistep || (isMultistep && !hasVariants)) {
      return 'showNinja'
    } else {
      return 'hideBoth'
    }
  }

  const state = getState()

  return (
    <>
      {
        {
          showNinja: <NinjaPreview />,
          showPreview: <MultiStepPreview />,
          hideBoth: <></>,
        }[state]
      }
    </>
  )
}

export default Preview
